var eurowater = eurowater || {};
eurowater.officesSearch = {
    init: function () {
        if ( jQuery( '.js-eurowater-offices-search-result' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-eurowater-offices-search-results' );
                e4.handlebars.registerHelpers( 'compare' );
                eurowater.officesSearch.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-eurowater-offices-search-form' ).on( 'submit keyup', function ( event ) {
            event.preventDefault();
            eurowater.officesSearch.toggleInputGroupState( event.target );
        } ).find( '.js-eurowater-offices-search-input' ).on( 'input', function ( event ) {
            e4.util.debounce( function ( event ) {
                if (jQuery('.js-eurowater-offices-search-input').val().length > 3) {
                    jQuery( event.target ).closest( '.js-eurowater-offices-search-form' ).triggerHandler( 'submit' );
                    eurowater.officesSearch.result.get( jQuery( event.target ).serialize() );
                    eurowater.officesSearch.show();
                } else
                {
                    eurowater.officesSearch.hide();
                }
            }, e4.settings.debounceDelay.input ).apply( event.target, [ event ] );
        } );
        
        jQuery( '.js-eurowater-offices-search-clear' ).on( 'click', function ( event ) {
            eurowater.officesSearch.clearInput( event.target );
        } );
    },
    toggleInputGroupState: function ( domElm ) {
        var jSearchInputGroup = jQuery( domElm ).closest( '.js-eurowater-offices-search-input-group' );
        if ( domElm.value === '' ) {
            jSearchInputGroup.addClass( 'is-empty' );
        }
        else {
            jSearchInputGroup.removeClass( 'is-empty' );
        }
    },
    clearInput: function ( domElm ) {
        jQuery( domElm ).closest( '.js-eurowater-offices-search-input-group' ).find( '.js-eurowater-offices-search-input' ).val( '' ).trigger( 'focus' ).triggerHandler( 'input' );
    },
    show: function () {
        jQuery('.js-eurowater-offices-search-result').find('.js-eurowater-offices-search-result-status').removeClass( 'is-empty' );
        jQuery('.js-eurowater-offices-search-results').removeClass( 'is-empty' );
    },
    hide: function ( domElm ) {
        jQuery('.js-eurowater-offices-search-result').find('.js-eurowater-offices-search-result-status').addClass( 'is-empty' );
        jQuery('.js-eurowater-offices-search-results').addClass( 'is-empty' );
    },
    result: {
        count: 0,
        get: function ( objData ) {
            console.log('get: ', objData);
            var jqXHR = jQuery.ajax( {
                url: e4.settings.search.result.offices.url + encodeURIComponent( jQuery.trim( objData.value ) ),
                data: objData,
                method: 'GET',
                dataType: 'json',
                beforeSend: function ( objData ){
                   jQuery( '.js-e-search-loading-overlay' ).addClass( 'is-loading' );
                },
                cache: false
            } );
            jqXHR.done( function ( data ) {
                eurowater.officesSearch.result.build( data );
                jQuery( '.js-e-search-loading-overlay' ).removeClass( 'is-loading' );
            } );
        },
        build: function ( data ) {
            jQuery( '.js-eurowater-offices-search-results' ).html( e4.handlebars.tmpl.eurowaterOfficesSearchResults( data ) );
        }
    }
};
